import { ConnectIntegrationForm } from "../connect-integration-form"
import { use_connect_redirect_to } from "../use_connect_redirect_to"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectAwgPage(props: any = {}) {
  const redirectTo = use_connect_redirect_to(props.redirectTo)

  return (
    <ConnectIntegrationForm
      integrationName="awg"
      redirectTo={redirectTo}
      logoSrc="/img/integration/awg.png"
      logoAlt="Associated Wholesale Grocers"
      description="Enter your AWG Connect credentials (awgconnect.awginc.com) to sync your check remittances, invoice adjustments and chargeback invoices."
    />
  )
}
